import { buildAddressInputSchemas } from '../address/create-input.js';
import { VendorAddressType } from './rules.js';
export { addressNameSchema, nameSchema } from '../address/create-input.js';
export const { createAddressInputSchema: createVendorAddressInputSchema, typeIdSchema } = buildAddressInputSchemas(VendorAddressType);
//# sourceMappingURL=create-input.js.map